var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBoxOutlined = function SvgBoxOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#3D3935",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.444 5.121 8.074 1 16 5.795 8.303 9.889z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5.788v7.842l-7.77 4.398L.445 13.04.34 5.049m7.882 13.062V9.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.111 3.6 7.853 4.82v2.358l2.37-1.293V7.167L5.39 2.333"
  }))));
};
export default SvgBoxOutlined;